import React, {useEffect, useState} from 'react';
import {Button, Form, Input, message, Modal, Select, Space} from 'antd';
import {useBoolean} from 'react-hanger';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import {CreateSubmissionModel, SubmissionApi, TermApi, TermStatus} from '../../scaffold';
import Text from 'antd/lib/typography/Text';
import DateFormat from '../../utils/DateFormat';
import TermStatusTag from '../Term/TermStatusTag';
import CommonApiErrorHandler from '../../utils/HttpInstance';
import {enterpriseMentorFields, requiresAdditionalDetails, thesisTypes} from './additionalDetails';

export default function SubmissionCreateBtn(props: {refresh: () => any}) {
  const isDialog = useBoolean(false);
  const [form] = Form.useForm<CreateSubmissionModel>();
  const [termId, setTermId] = useState<number>();
  const listTerm = useOpenApiFpRequest(TermApi, TermApi.prototype.termListGet);
  const createState = useOpenApiFpRequest(SubmissionApi, SubmissionApi.prototype.submissionCreatePost);
  const requiresDetails = requiresAdditionalDetails(listTerm.data?.find(term => term.id === termId)?.name);

  function create(values: CreateSubmissionModel) {
    const model: CreateSubmissionModel = {title: values.title.trim(), termId: values.termId};
    if (requiresDetails) {
      enterpriseMentorFields.forEach(field => {
        model[field.name] = values[field.name]?.trim();
      });
      model.thesisType = values.thesisType;
    }
    createState
      .request({
        createSubmissionModel: model,
      })
      .then(() => {
        message.success('已提交申请');
        isDialog.setFalse();
        form.resetFields();
        setTermId(undefined);
        props.refresh();
      })
      .catch(CommonApiErrorHandler);
  }

  useEffect(() => {
    listTerm.requestSync({});
  }, []);
  return (
    <React.Fragment>
      <Button onClick={isDialog.setTrue} type={'primary'}>
        创建新的申请
      </Button>
      <Modal title={'提交新申请'} visible={isDialog.value} onCancel={isDialog.setFalse} confirmLoading={createState.loading} onOk={() => form.submit()}>
        <Form form={form} layout={'vertical'} onFinish={create}>
          <Form.Item name={'title'} label={'论文名称'} rules={[{required: true, whitespace: true, message: '请输入论文名称'}]}>
            <Input placeholder={'请输入论文名称'} />
          </Form.Item>
          <Form.Item name={'termId'} label={'答辩批次'} rules={[{required: true, message: '请选择批次'}]}>
            <Select<number> placeholder={'请选择批次'} onChange={setTermId} allowClear>
              {listTerm.data?.map(term => (
                <Select.Option key={term.id} value={term.id as number} disabled={term.termStatus !== TermStatus.进行中}>
                  <Space size={2}>
                    <TermStatusTag status={term.termStatus as any} />
                    <Text>{term.name}</Text>
                  </Space>
                  <div>
                    <Text type={'secondary'} style={{fontSize: 12}}>
                      {DateFormat.simple(term.beginTime)} 到 {DateFormat.simple(term.endTime)}
                    </Text>
                  </div>
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          {requiresDetails && (
            <React.Fragment>
              {enterpriseMentorFields.map(field => (
                <Form.Item key={field.name} name={field.name} label={field.label} rules={[{required: true, whitespace: true, message: `请填写${field.label}`}]}>
                  <Input placeholder={`请输入${field.label}`} />
                </Form.Item>
              ))}
              <Form.Item name={'thesisType'} label={'论文形式'} rules={[{required: true, message: '请选择论文形式'}]}>
                <Select placeholder={'请选择论文形式'} allowClear>
                  {thesisTypes.map(type => (
                    <Select.Option key={type} value={type}>
                      {type}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </React.Fragment>
          )}
        </Form>
      </Modal>
    </React.Fragment>
  );
}
